export const ITEM_NUMBER = 'itemNumber';
export const SKILL = 'skill';
export const DIFFICULTY_LEVEL = 'difficultLevelName';
export const TIME_SPENT = 'totalTimeTaken';
